import React, { useContext } from "react";
import "./statusAll.css";
import TopBar from "../../../components/TopBarComponent/Topbar";
import LeftArrow from "../../../assets/images/leftArrow.svg";
import { StatusAllContext } from "../StatusAllView";
import { Container, Dropdown } from "react-bootstrap";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
import DataTable from "../../../components/DataTableComponent/DataTable";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import ContentData from "../../../constants/contentFile.json";

const StatusAllPage = ({ textContents }) => {
  const {
    goBack,
    totalPageCount,
    currentPage,
    statusAllData,
    newExcel,
    statusAllExcelDownload,
    onPageChange,
    spinnerStatus,
    categoryListDropDown,
    setShowAlert,
    showAlert,
    categoryTypeData,
    setCurrentPage,
    statusCode,
    alertMessage,
    visitorType,
    setVisitorType,
    logout,
    spinnerDownloadStatus,
    catogorySpinner
  } = useContext(StatusAllContext);
  console.log("spinnerStatus",spinnerStatus)
  const tableHeader = [
    {
      title: "Name & Contact",
      prop: "empName",
      cell: (row) => (
        <div className="ertHeaderEvacuation">
          <div>{row.empName}</div>
          <span>{row.contact}</span>
        </div>
      ),
    },
    { title: "Employee code", prop: "empCode" },
    { title: "Category", prop: "CategoryFName" },
    { title: "Zone", prop: "DeviceFName" },
    { title: "Working Unit", prop: "WorkingUnit" },
    // { title: "Contact No", prop: "contact" },
  ];

  const categoryList = [
    { id: "", name: "All Categories" },
    ...categoryListDropDown,
  ];

  return (
    <div>
       {spinnerStatus && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
              {catogorySpinner && (
                <div className="spinner-overlay-vehicle-report">
                  <Spinner size="xl" className="custom-spinner-vehicle-report" />
                </div>
              )}
      <TopBar />
      <Container>
        <div className="filterContainerStatusAll">
          <div className="arrowContainerStatusAll" onClick={() => goBack()}>
            <img src={LeftArrow} alt="img" className="leftArrowStatusAll" />
          </div>
          <div className="filterByContainerStatusAll">
            <span className="filterByZoneText">
              {textContents.filteredByAll}
            </span>
            <div className="text-align">
              <div className="dropDownByFiltered">
                <DropDownItem
                  selectedItem={visitorType}
                  setSelectedItem={setVisitorType}
                  categoryRequired={false}
                  list={categoryList}
                  onDropdownChange={(item) => {
                    categoryTypeData(item.id);
                    //setCurrentPage(1);
                  }}
                />
              </div>
              <span className="download-text">
                <a
                  className={newExcel ? "excel-download" : "disabled-button"}
                  href={newExcel ? `${baseURL}/excel/${newExcel}` : null}
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  {spinnerDownloadStatus ? <Spinner size="sm" /> : "Download Excel"}
                </a>
              </span>
            </div>
          </div>
        </div>
        <div className="tableContainerStatusAll">
          <DataTable
            tableData={statusAllData}
            header={tableHeader}
            isPagination={true}
            onPageChange={(e) => {
              onPageChange(e);
            }}
            currentPage={currentPage}
            pageCount={totalPageCount}
          />
        </div>
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default StatusAllPage;
